import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const Th = styled.td`
  ${({ displayState }) => css`
    ${displayState?.borderRight && css`
      border-right: ${displayState.borderRight};
    `}
    ${displayState?.borderLeft && css`
      border-left: ${displayState.borderLeft};
    `}
    ${displayState?.borderTop && css`
      border-top: ${displayState.borderTop};
    `}
    ${displayState?.borderBottom && css`
      border-bottom: ${displayState.borderBottom};
    `}
    ${displayState?.background && css`
      background: ${displayState.background};
    `}
    ${displayState?.borderRadius && css`
      border-radius: ${displayState.borderRadius};
    `}
    ${displayState?.width && css`
      width: ${displayState.width};
      min-width: ${displayState.width};
    `}
  `} 
`;

export default Wrapper(Th)